<template>
    <div class="tabs">
        <router-link
                class="nav-tab"
                :class="{active: active('trims')}"
                :to="{name: 'trims'}"
        >Trims</router-link>

        <!-- My trims tab hidden -->
        <!--
        <router-link  v-if="hasUserAccess"
                class="nav-tab"
                :class="{active: active('my-trims')}"
                :to="{name: 'my-trims'}"
        >My trims</router-link>
        -->

        <template v-if="hasAdminAccess">
            <router-link
                    class="nav-tab"
                    :class="{active: active('settings', 'settingsServer', 'settingsExport')}"
                    :to="{name: 'settings'}"
            >Settings</router-link>

            <router-link
                    class="nav-tab"
                    :class="{active: active('users')}"
                    :to="{name: 'users'}"
            >Users</router-link>

            <div v-if="active(['user', 'userProfile', 'userCreatedTrims', 'userStatistic'])"
                 class="nav-tab active text-overflow"
            >{{ userName }}</div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "TabsMain",

        props: [
            'current',
            'userName',
        ],

        computed: {
            ...mapGetters('authentication', [
                'hasUserAccess',
                'hasAdminAccess',
            ]),

        },

        methods: {
            active(...args) {
                return args.flat().find(page => page === this.current);
            },

        },

    }
</script>

<style>
    .tabs {
        display: flex;
        flex-wrap: wrap;
        min-width: 80%;
        margin: 0 0 20px;
        border-bottom: 1px solid #dee2e6;
    }

    .nav-tab {
        margin: 0 4px -1px 0;
        padding: 8px 16px;
        border: 1px solid #dee2e6;
        border-radius: 4px 4px 0 0;
        color: inherit;
        background: #eee;
        transition: 0.3s ease;
        cursor: pointer;
    }

    .nav-tab:hover {
        color: inherit;
        background: #ddd;
    }

    .nav-tab.active {
        color: #495057;
        border-color: #dee2e6 #dee2e6 #fff;
        background: #fff !important;
        cursor: default;
    }

    .text-overflow {
        max-width: 250px;
    }
</style>